function Arrow(props) {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.33337 10.5013C3.33337 10.0411 3.70647 9.66797 4.16671 9.66797H15.8334C16.2936 9.66797 16.6667 10.0411 16.6667 10.5013C16.6667 10.9615 16.2936 11.3346 15.8334 11.3346H4.16671C3.70647 11.3346 3.33337 10.9615 3.33337 10.5013Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.4107 4.07611C9.73614 3.75067 10.2638 3.75067 10.5892 4.07611L16.4225 9.90944C16.748 10.2349 16.748 10.7625 16.4225 11.088L10.5892 16.9213C10.2638 17.2467 9.73614 17.2467 9.4107 16.9213C9.08527 16.5958 9.08527 16.0682 9.4107 15.7428L14.6548 10.4987L9.4107 5.25462C9.08527 4.92918 9.08527 4.40155 9.4107 4.07611Z"
        fill="currentColor"
      />
    </svg>
  );
}

function Globe(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_20927)">
        <path
          d="M9.99996 18.3327C14.6023 18.3327 18.3333 14.6017 18.3333 9.99935C18.3333 5.39698 14.6023 1.66602 9.99996 1.66602C5.39759 1.66602 1.66663 5.39698 1.66663 9.99935C1.66663 14.6017 5.39759 18.3327 9.99996 18.3327Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.66663 10H18.3333"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.99996 1.66602C12.0844 3.94798 13.2689 6.90938 13.3333 9.99935C13.2689 13.0893 12.0844 16.0507 9.99996 18.3327C7.91556 16.0507 6.731 13.0893 6.66663 9.99935C6.731 6.90938 7.91556 3.94798 9.99996 1.66602Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_20927">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
function Location(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_20933)">
        <path
          d="M17.5 8.33398C17.5 14.1673 10 19.1673 10 19.1673C10 19.1673 2.5 14.1673 2.5 8.33398C2.5 6.34486 3.29018 4.43721 4.6967 3.03068C6.10322 1.62416 8.01088 0.833984 10 0.833984C11.9891 0.833984 13.8968 1.62416 15.3033 3.03068C16.7098 4.43721 17.5 6.34486 17.5 8.33398Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 10.834C11.3807 10.834 12.5 9.7147 12.5 8.33398C12.5 6.95327 11.3807 5.83398 10 5.83398C8.61929 5.83398 7.5 6.95327 7.5 8.33398C7.5 9.7147 8.61929 10.834 10 10.834Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_20933">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
function People(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_20939)">
        <path
          d="M6.25 10.8333C5.50832 10.8333 4.7833 10.6134 4.16661 10.2013C3.54993 9.78929 3.06928 9.20362 2.78545 8.5184C2.50162 7.83318 2.42736 7.07918 2.57206 6.35175C2.71675 5.62432 3.0739 4.95613 3.59835 4.43169C4.1228 3.90724 4.79098 3.55009 5.51841 3.40539C6.24584 3.2607 6.99984 3.33496 7.68506 3.61879C8.37029 3.90262 8.95596 4.38326 9.36801 4.99995C9.78007 5.61663 10 6.34166 10 7.08334C9.9989 8.07756 9.60345 9.03075 8.90043 9.73377C8.19741 10.4368 7.24422 10.8322 6.25 10.8333ZM6.25 5C5.83796 5 5.43516 5.12219 5.09256 5.35111C4.74996 5.58003 4.48293 5.9054 4.32525 6.28608C4.16757 6.66676 4.12631 7.08565 4.2067 7.48977C4.28708 7.8939 4.4855 8.26512 4.77686 8.55648C5.06822 8.84784 5.43943 9.04625 5.84356 9.12664C6.24769 9.20703 6.66658 9.16577 7.04726 9.00809C7.42794 8.8504 7.75331 8.58338 7.98223 8.24077C8.21115 7.89817 8.33333 7.49538 8.33333 7.08334C8.33333 6.5308 8.11384 6.0009 7.72314 5.6102C7.33244 5.2195 6.80253 5 6.25 5ZM12.5 19.1667V18.75C12.5 17.0924 11.8415 15.5027 10.6694 14.3306C9.49731 13.1585 7.9076 12.5 6.25 12.5C4.5924 12.5 3.00268 13.1585 1.83058 14.3306C0.65848 15.5027 0 17.0924 0 18.75L0 19.1667C0 19.3877 0.0877974 19.5996 0.244078 19.7559C0.400358 19.9122 0.61232 20 0.833333 20C1.05435 20 1.26631 19.9122 1.42259 19.7559C1.57887 19.5996 1.66667 19.3877 1.66667 19.1667V18.75C1.66667 17.5344 2.14955 16.3686 3.00909 15.5091C3.86864 14.6496 5.03442 14.1667 6.25 14.1667C7.46558 14.1667 8.63136 14.6496 9.49091 15.5091C10.3504 16.3686 10.8333 17.5344 10.8333 18.75V19.1667C10.8333 19.3877 10.9211 19.5996 11.0774 19.7559C11.2337 19.9122 11.4457 20 11.6667 20C11.8877 20 12.0996 19.9122 12.2559 19.7559C12.4122 19.5996 12.5 19.3877 12.5 19.1667ZM20 15C20 13.8739 19.674 12.7719 19.0614 11.827C18.4489 10.8821 17.5759 10.1347 16.5479 9.67498C15.5199 9.21529 14.3808 9.06299 13.2681 9.23645C12.1555 9.40991 11.1168 9.90172 10.2775 10.6525C10.1948 10.7252 10.1273 10.8135 10.079 10.9124C10.0306 11.0113 10.0023 11.1188 9.99573 11.2287C9.98915 11.3386 10.0044 11.4487 10.0406 11.5526C10.0768 11.6566 10.1333 11.7523 10.2067 11.8343C10.2801 11.9164 10.3691 11.983 10.4684 12.0305C10.5678 12.0779 10.6755 12.1052 10.7855 12.1108C10.8954 12.1163 11.0054 12.1 11.109 12.0629C11.2126 12.0257 11.3078 11.9684 11.3892 11.8942C11.9887 11.358 12.7306 11.0069 13.5253 10.8831C14.3201 10.7593 15.1336 10.8681 15.8678 11.1965C16.6021 11.5249 17.2255 12.0588 17.663 12.7337C18.1005 13.4086 18.3333 14.1957 18.3333 15C18.3333 15.221 18.4211 15.433 18.5774 15.5893C18.7337 15.7455 18.9457 15.8333 19.1667 15.8333C19.3877 15.8333 19.5996 15.7455 19.7559 15.5893C19.9122 15.433 20 15.221 20 15ZM14.5833 7.5C13.8417 7.5 13.1166 7.28007 12.4999 6.86801C11.8833 6.45596 11.4026 5.87029 11.1188 5.18507C10.835 4.49984 10.7607 3.74584 10.9054 3.01841C11.0501 2.29098 11.4072 1.6228 11.9317 1.09835C12.4561 0.573904 13.1243 0.216752 13.8517 0.0720569C14.5792 -0.0726377 15.3332 0.00162482 16.0184 0.285453C16.7036 0.569282 17.2893 1.04993 17.7013 1.66661C18.1134 2.2833 18.3333 3.00832 18.3333 3.75C18.3322 4.74423 17.9368 5.69741 17.2338 6.40043C16.5307 7.10346 15.5776 7.4989 14.5833 7.5ZM14.5833 1.66667C14.1713 1.66667 13.7685 1.78885 13.4259 2.01777C13.0833 2.24669 12.8163 2.57207 12.6586 2.95274C12.5009 3.33342 12.4596 3.75231 12.54 4.15644C12.6204 4.56057 12.8188 4.93178 13.1102 5.22314C13.4016 5.5145 13.7728 5.71292 14.1769 5.79331C14.581 5.87369 14.9999 5.83243 15.3806 5.67475C15.7613 5.51707 16.0866 5.25004 16.3156 4.90744C16.5445 4.56484 16.6667 4.16205 16.6667 3.75C16.6667 3.19747 16.4472 2.66756 16.0565 2.27686C15.6658 1.88616 15.1359 1.66667 14.5833 1.66667Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_20939">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

function Hash(props) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.75 5.2513C1.75 4.92914 2.01117 4.66797 2.33333 4.66797H11.6667C11.9888 4.66797 12.25 4.92914 12.25 5.2513C12.25 5.57347 11.9888 5.83464 11.6667 5.83464H2.33333C2.01117 5.83464 1.75 5.57347 1.75 5.2513Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.75 8.7513C1.75 8.42914 2.01117 8.16797 2.33333 8.16797H11.6667C11.9888 8.16797 12.25 8.42914 12.25 8.7513C12.25 9.07347 11.9888 9.33464 11.6667 9.33464H2.33333C2.01117 9.33464 1.75 9.07347 1.75 8.7513Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.89772 1.17159C6.21792 1.20717 6.44865 1.49558 6.41307 1.81577L5.2464 12.3158C5.21082 12.636 4.92241 12.8667 4.60222 12.8311C4.28202 12.7955 4.05129 12.5071 4.08687 12.1869L5.25354 1.68694C5.28912 1.36674 5.57753 1.13601 5.89772 1.17159Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.39772 1.17159C9.71792 1.20717 9.94865 1.49558 9.91307 1.81577L8.7464 12.3158C8.71082 12.636 8.42241 12.8667 8.10222 12.8311C7.78202 12.7955 7.55129 12.5071 7.58687 12.1869L8.75354 1.68694C8.78912 1.36674 9.07753 1.13601 9.39772 1.17159Z"
        fill="currentColor"
      />
    </svg>
  );
}

function Cancel(props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 6L6 18"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 6L18 18"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function Logo(props) {
  return (
    <svg
      width="88"
      height="34"
      viewBox="0 0 88 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.125 0.999999L14.5781 11.9062H14.8281L21.3125 0.999999H28.9531L19.1875 17L29.1719 33H21.3906L14.8281 22.0781H14.5781L8.01563 33H0.265625L10.2813 17L0.453125 0.999999H8.125ZM44.9844 33.4375C42.5781 33.4375 40.4375 33.0469 38.5625 32.2656C36.6979 31.474 35.2344 30.3958 34.1719 29.0312C33.1094 27.6667 32.5781 26.1198 32.5781 24.3906C32.5781 23.0573 32.8802 21.8333 33.4844 20.7188C34.099 19.5938 34.9323 18.6615 35.9844 17.9219C37.0365 17.1719 38.2135 16.6927 39.5156 16.4844V16.2656C37.8073 15.9219 36.4219 15.0937 35.3594 13.7812C34.2969 12.4583 33.7656 10.9219 33.7656 9.17187C33.7656 7.51562 34.25 6.04167 35.2188 4.75C36.1875 3.44792 37.5156 2.42708 39.2031 1.6875C40.901 0.937499 42.8281 0.562499 44.9844 0.562499C47.1406 0.562499 49.0625 0.937499 50.75 1.6875C52.4479 2.4375 53.7813 3.46354 54.75 4.76562C55.7188 6.05729 56.2083 7.52604 56.2187 9.17187C56.2083 10.9323 55.6667 12.4687 54.5937 13.7812C53.5208 15.0937 52.1458 15.9219 50.4688 16.2656V16.4844C51.75 16.6927 52.9115 17.1719 53.9531 17.9219C55.0052 18.6615 55.8385 19.5938 56.4531 20.7188C57.0781 21.8333 57.3958 23.0573 57.4063 24.3906C57.3958 26.1198 56.8594 27.6667 55.7969 29.0312C54.7344 30.3958 53.2656 31.474 51.3906 32.2656C49.526 33.0469 47.3906 33.4375 44.9844 33.4375ZM44.9844 28.4687C46.0573 28.4687 46.9948 28.276 47.7969 27.8906C48.599 27.4948 49.224 26.9531 49.6719 26.2656C50.1302 25.5677 50.3594 24.7656 50.3594 23.8594C50.3594 22.9323 50.125 22.1146 49.6563 21.4063C49.1875 20.6875 48.5521 20.125 47.75 19.7187C46.9479 19.3021 46.026 19.0937 44.9844 19.0937C43.9531 19.0937 43.0313 19.3021 42.2187 19.7187C41.4063 20.125 40.7656 20.6875 40.2969 21.4063C39.8385 22.1146 39.6094 22.9323 39.6094 23.8594C39.6094 24.7656 39.8333 25.5677 40.2813 26.2656C40.7292 26.9531 41.3594 27.4948 42.1719 27.8906C42.9844 28.276 43.9219 28.4687 44.9844 28.4687ZM44.9844 14.1719C45.8802 14.1719 46.6771 13.9896 47.375 13.625C48.0729 13.2604 48.6198 12.7552 49.0156 12.1094C49.4115 11.4635 49.6094 10.7187 49.6094 9.875C49.6094 9.04167 49.4115 8.3125 49.0156 7.6875C48.6198 7.05208 48.0781 6.55729 47.3906 6.20313C46.7031 5.83854 45.901 5.65625 44.9844 5.65625C44.0781 5.65625 43.276 5.83854 42.5781 6.20313C41.8802 6.55729 41.3333 7.05208 40.9375 7.6875C40.5521 8.3125 40.3594 9.04167 40.3594 9.875C40.3594 10.7187 40.5573 11.4635 40.9531 12.1094C41.349 12.7552 41.8958 13.2604 42.5938 13.625C43.2917 13.9896 44.0885 14.1719 44.9844 14.1719ZM74.6836 33.7031C71.9961 33.6927 69.6836 33.0312 67.7461 31.7187C65.819 30.4062 64.3346 28.5052 63.293 26.0156C62.2617 23.526 61.7513 20.5312 61.7617 17.0312C61.7617 13.5417 62.2773 10.5677 63.3086 8.10937C64.3503 5.65104 65.8346 3.78125 67.7617 2.5C69.6992 1.20833 72.0065 0.562499 74.6836 0.562499C77.3607 0.562499 79.6628 1.20833 81.5898 2.5C83.5273 3.79167 85.0169 5.66667 86.0586 8.125C87.1003 10.5729 87.6159 13.5417 87.6055 17.0312C87.6055 20.5417 87.0846 23.5417 86.043 26.0312C85.0117 28.5208 83.5326 30.4219 81.6055 31.7344C79.6784 33.0469 77.3711 33.7031 74.6836 33.7031ZM74.6836 28.0937C76.5169 28.0937 77.9805 27.1719 79.0742 25.3281C80.168 23.4844 80.7096 20.7187 80.6992 17.0312C80.6992 14.6042 80.4492 12.5833 79.9492 10.9687C79.4596 9.35417 78.7617 8.14062 77.8555 7.32812C76.9596 6.51562 75.9023 6.10938 74.6836 6.10938C72.8607 6.10938 71.4023 7.02083 70.3086 8.84375C69.2148 10.6667 68.6628 13.3958 68.6523 17.0312C68.6523 19.4896 68.8971 21.5417 69.3867 23.1875C69.8867 24.8229 70.5898 26.0521 71.4961 26.875C72.4023 27.6875 73.4648 28.0937 74.6836 28.0937Z"
        fill="currentColor"
      />
    </svg>
  );
}

export { Arrow, Globe, Location, People, Hash, Cancel, Logo };